"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _CatalogGroupPage = require("CatalogGroupPage");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var qd = {};

function lastQueryForIdentifier(ident) {
  if (ident == 'search') {
    var cookieData;

    if (typeof document != 'undefined' && document.cookie) {
      cookieData = document.cookie.split(/\s*;\s*/).map(function (item) {
        return item.split('=');
      }).map(function (_ref) {
        var _ref2 = babelHelpers.toArray(_ref),
            key = _ref2[0],
            value = _ref2.slice(1);

        return [key, value.join('=')].map(decodeURIComponent);
      }).reduce(function (obj, _ref3) {
        var _ref4 = babelHelpers.slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        obj[key] = value;
        return obj;
      }, {});

      if (cookieData["lastQuery"]) {
        var lastQuery = cookieData.lastQuery;

        try {
          lastQuery = JSON.parse(lastQuery);
        } catch (e) {
          lastQuery = {
            initialSort: "newest",
            initialFilter: "",
            query: lastQuery
          };
        }

        if (lastQuery) return lastQuery;
      }

      return {
        query: "",
        initialSort: "newest",
        initialFilter: ""
      };
    }
  }

  return qd[ident] || {
    query: "",
    initialFilter: "",
    initialSort: "newest"
  };
}

function setLastQueryForIdentifier(ident, q) {
  if (ident == 'search') {
    document.cookie = 'lastQuery=' + encodeURIComponent(JSON.stringify(q)) + '; path=/; max-age=86400; expires=' + new Date(Date.now() + 86400000).toGMTString();
  } else {
    qd[ident] = q ? Object.assign({}, q) : q;
  }
}

var searchResults = {};

function resetSearch() {
  searchResults = {};
}

function _doSearch(query) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof document !== 'undefined') {
    $(document).off('profileUpdated', resetSearch);
    $(document).on('profileUpdated', resetSearch);
    var qs = [];
    if (query) qs.push('query=' + encodeURIComponent(query));
    Object.keys(properties).forEach(function (prop) {
      if (Array.isArray(properties[prop])) {
        properties[prop].forEach(function (value) {
          qs.push("".concat(encodeURIComponent("".concat(prop, "[]")), "=").concat(encodeURIComponent(value)));
        });
      } else {
        qs.push("".concat(encodeURIComponent(prop), "=").concat(encodeURIComponent(properties[prop])));
      }
    });
    qs = qs.join('&');
    if (searchResults[qs]) return searchResults[qs];
    return searchResults[qs] = (0, _fetch.default)('data/search?' + qs).then(function (result) {
      return result.json();
    });
  }
}

var SearchControl = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(SearchControl, _Component);

  function SearchControl() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SearchControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SearchControl)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "query", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "queryRan", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "initialSort", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "initialFilter", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      query: _this.query,
      queryRan: _this.queryRan,
      animated: false,
      data: null,
      removedTag: false
    };
    return _this;
  }

  babelHelpers.createClass(SearchControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.doSearch();
    }
  }, {
    key: "doSearch",
    value: function doSearch() {
      var _this2 = this;

      if (this.props.doSearch) {
        var q = this.state.query;
        this.props.doSearch(this.state.query).then(function (result) {
          if (q == _this2.state.query) {
            _this2.setState({
              data: result.items
            });
          }
        });
        return;
      }

      var ps = this.getSearchProperties();

      if (this.state.query || Object.keys(ps).length) {
        var qp = _doSearch(this.state.query, ps);

        var q = this.state.query;
        qp.then(function (result) {
          if (_this2.state.query == q) {
            _this2.setState({
              data: result.items
            });
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.queryRan != this.state.queryRan) {
        var q = lastQueryForIdentifier(this.props.id);
        q = Object.assign(q || {
          initialSort: "newest",
          initialFilter: ""
        }, {
          query: this.state.query || ""
        });
        q.query = this.state.query;

        if (!q.query) {
          q = null;
        }

        setLastQueryForIdentifier(this.props.id, q);
      }
    }
  }, {
    key: "removeTag",
    value: function removeTag() {
      this.setState({
        removedTag: true
      });
      this.doSearch();
    }
  }, {
    key: "getSearchProperties",
    value: function getSearchProperties() {
      var ps = Object.assign({}, this.props.searchProperties || {});
      if (this.state.removedTag) delete ps.tag;
      return ps;
    }
  }, {
    key: "autoFocus",
    value: function autoFocus(ref) {
      if (ref) ref.focus();
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "search-control"
      }, _react.default.createElement("form", {
        className: "search-field",
        onSubmit: this.runSearch
      }, _react.default.createElement("div", {
        className: "search-input-group"
      }, this.getSearchProperties().tag ? _react.default.createElement("button", {
        type: "button",
        className: "search-input-group-addon tag-button visible",
        onClick: this.removeTag
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "label"
      }), _react.default.createElement("span", null, this.getSearchProperties().tag), _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "clear"
      })) : null, _react.default.createElement("input", {
        placeholder: "What are you looking for?",
        className: "search-form-control",
        type: "text",
        ref: this.autoFocus,
        value: this.state.query,
        onChange: this.setQuery
      }), _react.default.createElement("button", {
        type: "button",
        className: _classList.default.join("search-input-group-addon-secondary", this.state.queryRan ? "visible" : ""),
        onClick: this.clearQuery
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "clear"
      })), _react.default.createElement("button", {
        type: "button",
        className: _classList.default.join('search-input-group-addon', this.state.query ? "visible" : ""),
        onClick: this.runSearch
      }, _react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "search"
      })))), _react.default.createElement("div", {
        className: _classList.default.join("search-result", Object.keys(this.getSearchProperties()).length || this.state.queryRan || this.props.doSearch ? "visible" : "", this.state.animated ? "animated" : "")
      }, this.state.data ? _react.default.createElement(_CatalogGroupPage.CatalogGroupPage, {
        newCards: true,
        className: "stack search catalog-group",
        groupTree: "",
        setSort: this.setSort,
        setFilter: this.setFilter,
        sortOrder: this.props.initialSort || "newest",
        base: "",
        defaultFilterType: "",
        filter: this.props.initialFilter || "",
        includeUserSpecifiedSort: false,
        itemStyle: "cards",
        minimumSortMenuCount: 1,
        isSearchPage: true,
        query: null,
        tileList: this.state.data
      }) : null));
    }
  }, {
    key: "setSort",
    value: function setSort(sort) {
      var q = lastQueryForIdentifier(this.props.id);
      q.initialSort = sort;
      setLastQueryForIdentifier(this.props.id, q);
    }
  }, {
    key: "setFilter",
    value: function setFilter(filter) {
      var q = lastQueryForIdentifier(this.props.id);
      q.initialFilter = filter;
      setLastQueryForIdentifier(this.props.id, q);
    }
  }, {
    key: "setQuery",
    value: function setQuery(event) {
      this.setState({
        query: event.target.value
      });
    }
  }, {
    key: "runSearch",
    value: function runSearch(event) {
      var _this3 = this;

      this.setState(function (st) {
        return {
          queryRan: true,
          animated: Object.keys(_this3.getSearchProperties()).length == 0 && !_this3.props.doSearch && st.queryRan != true,
          data: null
        };
      }, function () {
        var q = lastQueryForIdentifier(_this3.props.id);
        q = Object.assign(q || {
          initialSort: "newest",
          initialFilter: ""
        }, {
          query: _this3.state.query || ""
        });
        q.query = _this3.state.query;

        if (!q.query) {
          q = null;
        }

        setLastQueryForIdentifier(_this3.props.id, q);

        _this3.doSearch();
      });
      event.preventDefault();
      return false;
    }
  }, {
    key: "clearQuery",
    value: function clearQuery() {
      var _this4 = this;

      this.setState(function (st) {
        return {
          query: "",
          queryRan: false,
          animated: Object.keys(_this4.getSearchProperties()).length == 0 && !_this4.props.doSearch && st.queryRan != false
        };
      }, function () {
        if (Object.keys(_this4.getSearchProperties()).length) _this4.doSearch();
      });
    }
  }], [{
    key: "getControl",
    value: function getControl(identifier) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (identifier == 'events') props.initialSort = 'oldest';
      return _react.default.createElement(SearchControl, _extends({
        id: identifier
      }, lastQueryForIdentifier(identifier), props, {
        queryRan: !!lastQueryForIdentifier(identifier).query
      }));
    }
  }]);
  return SearchControl;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "query", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "queryRan", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "initialSort", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "newest";
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "initialFilter", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "removeTag", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "removeTag"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "autoFocus", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "autoFocus"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setSort", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setSort"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setQuery", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setQuery"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "runSearch", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "runSearch"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "clearQuery", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "clearQuery"), _class.prototype)), _class);
exports.default = SearchControl;